export default __webpack_public_path__ + "static/media/widget-placement-sibling-after.0a1431cd.svg";